import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { Button, Form, Input, Label } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';

class ForgotPasswordInternal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: ""
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    handleClick() {
        const email = this.state.email;
        if (email !== "") {
            this.props.accountsDispatch.forgotPassword(email);
            this.props.history.push(paths.homeEmailReset);
        }
    }

    handleEmail(e) {
        this.setState({
            email: e.target.value
        });
    }

    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleClick();
        }
    }

    render() {
        const emailId = "emailInput";
        const emailTitle = "Email";
        const submit = "Submit";

        return (
            <Form>
                <h1>Forgot Password</h1>
                <div>
                    <Label for={emailId}>{emailTitle}</Label>
                    <Input className="input" id={emailId} type="text" title={emailTitle} onChange={this.handleEmail} onKeyDown={this.handleKeyDown} />
                </div>
                <div className="button-gap">
                    <Button className="button" title={submit} onClick={this.handleClick}>{submit}</Button>
                </div>
            </Form>
        );
    }
}

const ForgotPasswordConnect = withRouter(connect(
    null,
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch)
    })
)(ForgotPasswordInternal));

export default class ForgotPassword extends React.Component {
    render() {
        return (
            <ErrorBoundary>
                <ForgotPasswordConnect />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js